module.exports = __webpack_public_path__ + "static/media/placeholder_sales.0f498727.png";